// ─── Industries (Comprehensive) ───
export const INDUSTRIES = [
  'Accounting & Tax', 'Advertising & Marketing', 'Aerospace & Defense', 'Agriculture & Farming',
  'Architecture & Planning', 'Automotive', 'Aviation & Airlines', 'Banking & Financial Services',
  'Biotechnology', 'Broadcasting & Media', 'Business Consulting', 'Chemicals',
  'Civil Engineering', 'Construction', 'Consumer Electronics', 'Consumer Goods',
  'Cybersecurity', 'E-commerce', 'Education & Training', 'Energy & Utilities',
  'Entertainment & Events', 'Environmental Services', 'Fashion & Apparel', 'Film & Video Production',
  'Fintech', 'Food & Beverage', 'Furniture & Home Decor', 'Gaming & Esports',
  'Government & Public Sector', 'Healthcare & Medical', 'Hospitality & Hotels',
  'Human Resources & Staffing', 'Import & Export', 'Information Technology', 'Insurance',
  'Interior Design', 'Investment & Venture Capital', 'Jewelry & Watches',
  'Legal Services', 'Logistics & Supply Chain', 'Luxury Goods',
  'Manufacturing', 'Marine & Shipping', 'Mining & Metals',
  'Non-Profit & NGO', 'Oil & Gas', 'Packaging & Printing',
  'Pharmaceuticals', 'Photography', 'Private Equity',
  'Property & Real Estate', 'Publishing', 'Recruitment',
  'Restaurants & Cafes', 'Retail & Wholesale', 'SaaS & Cloud Services',
  'Sports & Fitness', 'Telecommunications', 'Textiles',
  'Tourism & Travel', 'Transportation', 'Veterinary',
  'Waste Management', 'Water & Sanitation', 'Wellness & Spa',
  'Other',
].map(i => ({ value: i.toLowerCase().replace(/[^a-z0-9]+/g, '_'), label: i }));

// ─── Job Titles (B2B focused) ───
export const JOB_TITLES = [
  'CEO / Chief Executive Officer', 'CFO / Chief Financial Officer', 'CTO / Chief Technology Officer',
  'CMO / Chief Marketing Officer', 'COO / Chief Operating Officer', 'CIO / Chief Information Officer',
  'CHRO / Chief Human Resources Officer', 'CSO / Chief Sales Officer',
  'Founder', 'Co-Founder', 'Owner', 'Partner', 'Managing Director',
  'President', 'Vice President', 'Executive Vice President', 'Senior Vice President',
  'General Manager', 'Regional Manager', 'Country Manager', 'Branch Manager',
  'Director of Sales', 'Director of Marketing', 'Director of Operations',
  'Director of Finance', 'Director of Engineering', 'Director of Product',
  'Director of HR', 'Director of IT', 'Director of Business Development',
  'Sales Manager', 'Marketing Manager', 'Operations Manager', 'Project Manager',
  'Product Manager', 'Account Manager', 'Business Development Manager',
  'HR Manager', 'IT Manager', 'Finance Manager', 'Procurement Manager',
  'Head of Sales', 'Head of Marketing', 'Head of Engineering', 'Head of Design',
  'Head of Customer Success', 'Head of Growth', 'Head of Partnerships',
  'Team Lead', 'Supervisor', 'Coordinator', 'Specialist',
  'Consultant', 'Analyst', 'Advisor', 'Strategist',
  'Executive Assistant', 'Office Manager', 'Administrator',
  'Software Engineer', 'Data Scientist', 'Designer',
  'Sales Representative', 'Account Executive', 'Business Analyst',
  'Freelancer / Independent', 'Intern',
  'Other',
].map(t => ({ value: t, label: t }));

// ─── Countries (ISO 3166-1) ───
export const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina',
  'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
  'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana',
  'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon',
  'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
  'Congo (DRC)', 'Congo (Republic)', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador',
  'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea',
  'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia',
  'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya',
  'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
  'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives',
  'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru',
  'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea',
  'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama',
  'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
  'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
  'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland',
  'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga',
  'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
  'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe',
].map(c => ({ value: c, label: c }));

// ─── Revenue Ranges ───
export const REVENUE_RANGES = [
  { value: 'under_100k', label: 'Under $100K' },
  { value: '100k_500k', label: '$100K - $500K' },
  { value: '500k_1m', label: '$500K - $1M' },
  { value: '1m_5m', label: '$1M - $5M' },
  { value: '5m_10m', label: '$5M - $10M' },
  { value: '10m_50m', label: '$10M - $50M' },
  { value: '50m_100m', label: '$50M - $100M' },
  { value: '100m_500m', label: '$100M - $500M' },
  { value: '500m_1b', label: '$500M - $1B' },
  { value: 'over_1b', label: 'Over $1B' },
  { value: 'undisclosed', label: 'Undisclosed' },
];

// ─── Commission Periods ───
function generatePeriods() {
  const periods = [];
  const currentYear = new Date().getFullYear();
  for (let y = currentYear - 1; y <= currentYear + 2; y++) {
    for (let q = 1; q <= 4; q++) {
      periods.push({ value: `Q${q} ${y}`, label: `Q${q} ${y}` });
    }
    periods.push({ value: `H1 ${y}`, label: `H1 ${y} (Jan-Jun)` });
    periods.push({ value: `H2 ${y}`, label: `H2 ${y} (Jul-Dec)` });
    periods.push({ value: `FY ${y}`, label: `FY ${y} (Full Year)` });
  }
  return periods;
}
export const PERIODS = generatePeriods();

// ─── Employee Ranges ───
export const EMPLOYEE_RANGES = [
  { value: '1-10', label: '1-10 (Micro)' },
  { value: '11-50', label: '11-50 (Small)' },
  { value: '51-200', label: '51-200 (Medium)' },
  { value: '201-500', label: '201-500 (Mid-Market)' },
  { value: '501-1000', label: '501-1,000 (Large)' },
  { value: '1001-5000', label: '1,001-5,000 (Enterprise)' },
  { value: '5001-10000', label: '5,001-10,000' },
  { value: '10000+', label: '10,000+ (Mega)' },
];
